<div class="file-modal">
    <div class="file-modal__header">
        <h3>{{ modalTitle }}</h3>
        <button type="button" class="file-modal__close" (click)="activeModal.dismiss()" [disabled]="submitting"
            aria-label="Close">&times;</button>
    </div>

    <form class="file-modal__body" (ngSubmit)="save()">
        <label class="field">
            <span>Title</span>
            <input ngbAutofocus type="text" name="title" [(ngModel)]="title" autocomplete="off"
                [class.invalid]="titleInvalid" [class.shake]="shaking && titleInvalid" />
        </label>

        <label class="field">
            <span>Description</span>
            <input type="text" name="descr" [(ngModel)]="descr" autocomplete="off" />
        </label>

        <div class="field">
            <span>Category</span>
            <ng-select
                class="tool-select"
                name="categoryId"
                [items]="categories"
                bindLabel="categoryName"
                bindValue="id"
                placeholder="Select a category"
                [(ngModel)]="categoryId">
            </ng-select>
        </div>

        <div class="field">
            <span>File</span>
            <input type="file" name="file" (change)="onFileSelected($event)"
                [class.invalid]="fileInvalid" [class.shake]="shaking && fileInvalid" />
            @if (isEdit && existingFilename && !fileBase64) {
                <small class="hint">Current: {{ existingFilename }} — choose a file only to replace it.</small>
            }
        </div>

        @if (error) {
            <p class="error">{{ error }}</p>
        }

        <button type="submit" class="file-modal__submit" [disabled]="submitting">
            @if (submitting) {
                <span class="file-modal__spinner" aria-hidden="true"></span>
                <span>{{ isEdit ? 'Saving…' : 'Uploading…' }}</span>
            } @else {
                <span>Save</span>
            }
        </button>
    </form>
</div>
